import type { Variants } from 'framer-motion';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

const variants: Variants = {
	initial: {
		width: '1rem',
		className: 'border-[0.12rem] border-solid border-red-200',
		transition: {
			duration: 0.2,
		},
	},
	selected: {
		width: '1rem',
		className: 'border-[0.33rem] border-solid border-primary-500',
		transition: {
			duration: 0.2,
		},
	},
};

export const CardRadioButton = ({
	value,
	heading,
	body,
	recommended,
	selected,
	setSelected,
}: {
	heading: string;
	body: React.ReactNode;
	recommended?: boolean;
	value: string;
	selected: string;
	setSelected: (value: string) => void;
}) => {
	const { t } = useTranslation();
	const isSelected = selected === value;

	return (
		<li
			className={twMerge(
				'text-sm duration-400 w-full relative flex cursor-pointer items-start gap-2 p-4 font-medium transition-all focus:outline-none rounded-lg border bg-card text-card-foreground shadow-sm',
				isSelected && 'border-primary',
			)}
			id="unpublish"

			role="radio"
			aria-checked={isSelected}
			onClick={() => {
				setSelected(value);
			}}
			onKeyDown={(event) =>
				event.code === 'Enter' ? setSelected('unpublish') : null
			}
		>
			<div className="mt-0.5 size-4 rounded-full">
				<motion.div
					className="size-full rounded-full"
					variants={variants}
					initial="initial"
					animate={isSelected ? 'selected' : 'initial'}
				/>
			</div>
			<div className="flex flex-col gap-1 text-left">
				<p>
					<span className="font-semibold">{heading}</span>
					{recommended && (
						<span className="text-muted-foreground ml-1.5 text-xs">
							{t('general.recommended', '(recommended)')}
						</span>
					)}
				</p>
				{body}
			</div>
		</li>
	);
};
